// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.read-more-comp-module__read-more-inline___tXnsu,
.read-more-comp-module__read-more-block___bfS_o {
  background-color: initial;
  border: none;
}
.read-more-comp-module__read-more-inline___tXnsu:focus,
.read-more-comp-module__read-more-block___bfS_o:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}

.read-more-comp-module__read-more-inline___tXnsu {
  cursor: pointer;
  display: inline-block;
  margin-top: 0;
}
.read-more-comp-module__read-more-inline--primary-bold___A1eT3 {
  color: var(--primary600, #4b286d);
  font-weight: 600;
  text-decoration: underline;
  padding: 0px;
}

.read-more-comp-module__read-more-block___bfS_o {
  display: block;
  margin-top: 20px;
}
.read-more-comp-module__read-more--centre___gYyYR {
  margin: 20px auto 0;
}
.read-more-comp-module__read-more--text-block___COwdN {
  margin-top: 10px;
}
.read-more-comp-module__read-more--primary___ACwch {
  color: var(--primary600, #4b286d);
  text-decoration: underline;
  padding: 0;
}
.read-more-comp-module__read-more--link___eagix {
  text-decoration: none;
}
.read-more-comp-module__read-more--link___eagix:hover, .read-more-comp-module__read-more--link___eagix:focus, .read-more-comp-module__read-more--link___eagix:active {
  text-decoration: underline;
}

.read-more-comp-module__button-group-details____BlpT {
  margin-top: 8px;
  padding: 0;
  text-decoration: underline;
  color: var(--primary600, #4b286d);
}
.read-more-comp-module__button-group-details____BlpT:hover, .read-more-comp-module__button-group-details____BlpT:focus {
  color: var(--primary700, #371e47);
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/general/read-more-comp/read-more-comp.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_hocus.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;;EAEE,yBAAA;EACA,YAAA;AAMF;ACJI;;EACE,wCAAA;EACA,mBAAA;ADON;;AARA;EACE,eAAA;EACA,qBAAA;EACA,aAAA;AAWF;AATE;EACE,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;AAWJ;;AANE;EACE,cAAA;EACA,gBAAA;AASJ;AANE;EACE,mBAAA;AAQJ;AALE;EACE,gBAAA;AAOJ;AAJE;EACE,iCAAA;EACA,0BAAA;EACA,UAAA;AAMJ;AAHE;EACE,qBAAA;AAKJ;AAHI;EAGE,0BAAA;AAGN;;AAEA;EACE,eAAA;EACA,UAAA;EACA,0BAAA;EACA,iCAAA;AACF;AEpDE;EFqDE,iCAAA;AAEJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n.read-more-inline,\n.read-more-block {\n  background-color: initial;\n  border: none;\n  @include focus-outline;\n}\n.read-more-inline {\n  cursor: pointer;\n  display: inline-block;\n  margin-top: 0;\n\n  &--primary-bold {\n    color: color(primary600);\n    font-weight: 600;\n    text-decoration: underline;\n    padding: 0px;\n  }\n}\n\n.read-more {\n  &-block {\n    display: block;\n    margin-top: 20px;\n  }\n\n  &--centre {\n    margin: 20px auto 0;\n  }\n\n  &--text-block {\n    margin-top: 10px;\n  }\n\n  &--primary {\n    color: color(primary600);\n    text-decoration: underline;\n    padding: 0;\n  }\n\n  &--link {\n    text-decoration: none;\n\n    &:hover,\n    &:focus,\n    &:active {\n      text-decoration: underline;\n    }\n  }\n}\n\n.button-group-details {\n  margin-top: 8px;\n  padding: 0;\n  text-decoration: underline;\n  color: color(primary600);\n  @include hocus {\n    color: color(primary700);\n  }\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n","// Hocus\n// Generate :hover and :focus styles in one go.\n// http://www.456bereastreet.com/archive/201004/whenever_you_use_hover_also_use_focus/\n\n@mixin hocus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin notDisabledHocus() {\n  &:hover:not(:disabled),\n  &:focus:not(:disabled) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"read-more-inline": `read-more-comp-module__read-more-inline___tXnsu`,
	"read-more-block": `read-more-comp-module__read-more-block___bfS_o`,
	"read-more-inline--primary-bold": `read-more-comp-module__read-more-inline--primary-bold___A1eT3`,
	"read-more--centre": `read-more-comp-module__read-more--centre___gYyYR`,
	"read-more--text-block": `read-more-comp-module__read-more--text-block___COwdN`,
	"read-more--primary": `read-more-comp-module__read-more--primary___ACwch`,
	"read-more--link": `read-more-comp-module__read-more--link___eagix`,
	"button-group-details": `read-more-comp-module__button-group-details____BlpT`
};
export default ___CSS_LOADER_EXPORT___;
